import { render, staticRenderFns } from "./OrderlistTableCard.vue?vue&type=template&id=c5e86922"
import script from "./OrderlistTableCard.vue?vue&type=script&lang=js"
export * from "./OrderlistTableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports